import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { HotToastService } from '@ngneat/hot-toast';
import { Subscription } from 'rxjs';
import { ConfirmModalComponent } from 'src/app/account/components/confirm-modal/confirm-modal.component';
import { CountryDto, RegionDto, TestCentreDto } from 'src/app/core/dtos/dto';
import { BrandEnum, CountryEnum, TestTypeEnum } from 'src/app/core/dtos/enum';
import { CountryRegionService } from 'src/app/core/services/country-region.service';
import { ConfigHelper } from 'src/app/core/services/helpers/config.helper';
import { RegistrationService } from 'src/app/core/services/registration.service';

@Component({
  selector: 'app-location-dropdowns',
  templateUrl: './location-dropdowns.component.html',
  styleUrls: ['./location-dropdowns.component.scss']
})
export class LocationDropdownsComponent implements OnInit, OnDestroy {
  internationalTestCentres: TestCentreDto[];
  testCentres: TestCentreDto[];
  countries: CountryDto[];
  regions: RegionDto[];
  showRegion: boolean;
  showTestCentre: boolean;
  internationalTestCentresSubscription: Subscription;
  regionsSubscription: Subscription;
  countriesSubscription: Subscription;
  countryId: number;
  regionId: number;
  testCentreId: number;
  city: string;
  brandId: BrandEnum;

  @Output() loadTestSessionsForRegistration = new EventEmitter<{ testPurposeId: number; testTypeId: number; regionId: number }>();
  @Output() loadTestSessionsByTestCentre = new EventEmitter<{ testPurposeId: number; testTypeId: number; testCentreId: number }>();
  @Output() filterSittings = new EventEmitter<string>();
  @Output() reloadSittings = new EventEmitter<boolean>();
  @Input() cities: string[];
  @Input() testTypeId: number;
  @Input() testPurposeId: number;

  @ViewChild("warningModal") warningModal: ConfirmModalComponent;

  constructor(
    private countryRegionService: CountryRegionService,
    private toastService: HotToastService,
    private registrationService: RegistrationService,
    private configHelper: ConfigHelper
  ) { }

  ngOnInit(): void {
    this.brandId = this.configHelper.getBrandId();
    this.countriesSubscription = this.countryRegionService.getCountriesWithActiveTestCentres()
      .subscribe(
        (result) => {
          this.countries = result.content;
          if (this.testTypeId === TestTypeEnum.CELPIP_LS) {
            this.countries = result.content.filter(x => x.id === CountryEnum.Canada);
          }
          if (this.brandId === BrandEnum.CAEL) {
            this.getInternationalTestCentres();
          }
        },
        () => {
          this.toastService.warning("Unable to load test centres");
        }
      );
  }

  getRegionByCountry() {
    this.showTestCentre = false;
    this.testCentreId = null;
    this.regionId = null;
    this.showRegion = false;
    if (this.brandId === BrandEnum.CELPIP || this.brandId === BrandEnum.CAEL && Number(this.countryId) === CountryEnum.Canada) {
      this.regionsSubscription = this.countryRegionService.getRegionsWithCertainTestType(this.countryId, this.testTypeId)
        .subscribe(
          result => {
            this.regions = result.content;
            if (this.regions.length > 0) {
              this.showRegion = true;
            }
            this.reloadSittings.emit(!this.showRegion);
          },
          () => {
            this.toastService.warning("Unable to load test centres");
          });
    }
    else {
      this.testCentres = this.internationalTestCentres.filter(x => x.countryId === Number(this.countryId));
      if (this.testCentres.length > 0) {
        this.showTestCentre = true;
      }
      this.reloadSittings.emit(!this.showTestCentre);
    }
    this.selectCountryPostAction();
  }

  getInternationalTestCentres() {
    this.internationalTestCentresSubscription = this.registrationService.getInternationalTestCentres()
      .subscribe(
        result => {
          this.internationalTestCentres = result.content;
          //show coutries only if they have active test centres
          const countryIds = this.internationalTestCentres.map(x => x.countryId);
          this.countries = this.countries.filter(c => countryIds.indexOf(c.id) !== -1 || c.id === CountryEnum.Canada);
        },
        () => {
          this.toastService.warning("Unable to load international test centres");
        });
  }

  getTestCentreSittings() {
    this.city = null;
    const params = {
      testPurposeId: this.testPurposeId,
      testTypeId: this.testTypeId,
      regionId: this.regionId
    };
    this.loadTestSessionsForRegistration.emit(params);
  }

  filterSittingsByCentre() {
    const params = {
      testPurposeId: this.testPurposeId,
      testTypeId: this.testTypeId,
      testCentreId: this.testCentreId
    };
    this.loadTestSessionsByTestCentre.emit(params);
  }

  filterSittingsByCity() {
    this.filterSittings.emit(this.city);
  }

  selectCountryPostAction() {
    // TEC-14214: Nigerian Paymentech Integration Rollout
    //if (Number(this.countryId) === 158) { //Nigeria
    //  this.warningModal.open();
    //}
  }

  ngOnDestroy(): void {
    this.internationalTestCentresSubscription?.unsubscribe();
    this.regionsSubscription?.unsubscribe();
    this.countriesSubscription?.unsubscribe();
  }

}
